import AdDebuggerService from '@/api/admin/adDebugger.service'

export default {
  state: {
    adDebugger: {},
  },
  getters: {
    getAdDebugger: state => state.adDebugger,
  },
  actions: {
    async getAdDebugger({ commit }) {
      const adDebugger = await AdDebuggerService.getAdDebugger()
      commit('SET_AD_DEBUGGER', adDebugger)
    },
  },
  mutations: {
    SET_AD_DEBUGGER(state, adDebugger) {
      state.adDebugger = adDebugger
    },
  },
}
